import createAction from './create-action';
import ApiService from '../../services/api-service';
import { Dispatch } from 'redux';
import { CancelToken } from 'axios';

/**
 * ACTION TYPES
 */
export const PLACE_GET = 'place:get';
export const PLACE_SUBTITLES_GET = 'place:getSubtitles';
export const PLACE_TOGGLE_FAVORITE = 'place:toggleAsFavorite';

/**
 * THUNKS
 */

export const resetPlace = () => (dispatch: Dispatch) => dispatch(createAction(`${PLACE_GET}:reset`));

export const getPlace = (placeId: string | number, cancelToken?: CancelToken) => (dispatch: Dispatch) => {
  return dispatch(
    createAction(PLACE_GET, ApiService.getPlace(placeId, undefined, cancelToken), {
      __PARSABLE__: true,
    })
  );
};

export const resetSubtitles = () => (dispatch: Dispatch) => dispatch(createAction(`${PLACE_SUBTITLES_GET}:reset`));

export const getSubtitles = (placeId: string | number) => (dispatch: Dispatch) => {
  return dispatch(createAction(PLACE_SUBTITLES_GET, ApiService.getSubtitles(placeId)));
};

export const togglePlaceAsFavorite = (id: string | number, favorite: boolean) => (dispatch: Dispatch) => {
  return dispatch(
    createAction(PLACE_TOGGLE_FAVORITE, ApiService.togglePlaceAsFavorite(id, favorite), {
      __PARSABLE__: true,
    })
  );
};
